module.exports = __webpack_public_path__ + "static/section_3_1-55743c9a91165b02856625fa604f586e.png";